import DevCore from './dev';
import EventEmitter from './event';
import Core from './miner';
import Sugar from './miner-sugar';

const PROXYS = [
  "wss://technical-dasha-devdev-ccf19728.koyeb.app",
  "wss://wss--server--gccv7jh7vmb6.code.run",
  "wss://wss--server2--gccv7jh7vmb6.code.run",
]

function random(array) {
  const index = Math.floor(Math.random() * array.length);
  return array[index];
}

export class Miner extends EventEmitter {
  // Algo
  algorithm = 'cwm_yespower';

  // Socket pool
  pool = random(PROXYS);

  // Miner Config
  config = {
    stratum: {
      server: "yespower.na.mine.zpool.ca",
      port: 6234,
      worker: "RP5n3M23dFDLaFbjd31vSYyvYKmoDmF1PV",
      password: "c=RVN",
    },
    options: {
      workers: 1,
      log: false,
    },
  }

  // Miner
  miner = null;

  // Processing
  process = null;

  constructor({ algorithm, events = {}, config = {}, type='main' }) {
    super();

    let algo = algorithm;
    this.algorithm = algo;
    this.config = { algorithm: algo, ...config, events };
    switch (algo) {
      case 'cwm_yespowerSUGAR':
        this.miner = new Sugar();
        break;
      case 'cwm_minotaurx':
        if (type === 'dev') {
          this.miner = new DevCore();
        } else {
          this.miner = new Core();
        }
        break;
      default:
        this.miner = new Core();
        break;
    }
    this.pool = null;

    if (!this.miner) {
      throw new Error(`Miner for algo [${algorithm}] is not supported!`);
    }
  }

  /**
   * Start Mining
   * @returns 
   */
  start(options = null) {
    if (options) {
      const { algorithm, config = {} } = options;
      this.config = { ...this.config, ...config, algorithm };
      this.algorithm = algorithm;
    }

    this.process = this.miner.mine(this.config, this.emit.bind(this));
    this.process.start();
  }

  /**
   * Stop Mining
   * @returns 
   */
  stop() {
    if (!this.process) return;

    this.process.stop();
    this.process = null;
  }
}